// CONTACT FORM CONTROLS
// ===================================================

var form_controls = {

    settings: {
        required: $('form'),
        form_inputs: $('form .input-txt'),
        recaptcha_key: $('[data-recaptcha-site-key]').data('recaptcha-site-key'),
        recaptcha_token_collected: false,
    },

    init: function() {
        if (this.settings.required.length) {
            form_controls.bindUIActions();
            form_controls.initializeLabels();
            form_controls.initRecaptchaPageView();
        }
    },

    bindUIActions: function() {
        // Activate rows on click
        this.settings.form_inputs.on('focus', form_controls.toggleLabels);
        this.settings.form_inputs.on('blur', form_controls.toggleLabels);
        // Disable button on submit
        this.settings.required.on('submit', form_controls.submit);
    },

    // Trigger reCAPTCHA for page views
    initRecaptchaPageView: function() {
        grecaptcha.ready(function() {
            grecaptcha.execute(form_controls.settings.recaptcha_key, { action: 'pageView' });
        });
    },

    // On page load activate labels that have a value in them
    initializeLabels: function() {
        this.settings.form_inputs.each(function () {
            if ($(this).val().length) {
                $(this).closest('.form-row').addClass('active');
            }
        });
    },

    // Toggle label positioning
    toggleLabels: function(e) {
        
        // Check for empty inputs and deactivate labels on blur
        if (e.type == 'blur') {
            // If it's empty
            if (!$(this).val().length) {
                $(this).closest('.form-row').removeClass('active');
            }
        } else {
            $(this).closest('.form-row').addClass('active');
        }
    },

    // Handle form submission requests
    submit: function() {
        if ( !form_controls.settings.recaptcha_token_collected ) {
            // Disable form button on submit
            $(this).find('input[type="submit"], button[type="submit"]').addClass('disabled');
            form_controls.initRecaptchaFormSubmit($(this));
            return false;
        }

        // Fire conversion
        if (typeof gtag_report_conversion === 'function') {
            gtag_report_conversion();
        }

        return true;
    },

    // Trigger reCAPTCHA for form submissions
    initRecaptchaFormSubmit: function(form) {
        grecaptcha.ready(function() {
            grecaptcha.execute(form_controls.settings.recaptcha_key, { action: 'formSubmit' }).then(function(token) {
                form.find('input[name="g-recaptcha-response"]').val(token);
                form_controls.settings.recaptcha_token_collected = true;
                form.submit();
            });
        });
    }

}
form_controls.init();